import { FC, useState } from 'react';

import { Dialogs } from 'analytics/events/dialog';

import { useStores } from 'mobx/hooks/useStores';

import { FeatureIntroCodes } from 'models/Doctor';

import { useTicketClose } from 'hooks/useTicketClose';
import { ResolveTicketsData, useTicketResolve } from 'hooks/useTicketResolve';

import { MessageDialog } from 'components/UIkit/atoms/Dialog';

interface Props {
  isOpen: boolean;
  closeDialog: () => void;
  resolveTicketsData: ResolveTicketsData;
  action?: 'close' | 'resolve';
}

export const ResolveOrCloseTicketWithMessageForTheFirstTimeDialog: FC<Props> = ({
  isOpen,
  closeDialog,
  resolveTicketsData,
  action = 'resolve'
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const ticketResolve = useTicketResolve();
  const ticketClose = useTicketClose();
  const { userStore } = useStores();

  const actionText = action === 'close' ? 'Close' : 'Resolve';
  const actionTextLower = actionText.toLowerCase();

  const handleAction = async () => {
    try {
      setIsLoading(true);
      await userStore.updateIntroFinished(FeatureIntroCodes.ResolveTicketWithMessage);
      closeDialog();
      if (action === 'resolve') {
        await ticketResolve(resolveTicketsData);
      } else {
        await ticketClose({
          tickets: resolveTicketsData.tickets,
          patientId: resolveTicketsData.patientId
        });
      }
    } finally {
      closeDialog();
      setIsLoading(false);
    }
  };

  return (
    <MessageDialog
      id={Dialogs.ResolveTicketWithMessage}
      isOpen={isOpen}
      handleClose={closeDialog}
      title={`Patient Cannot Reply After ${actionText}`}
      primaryActionProps={{ text: actionText, onClick: handleAction, disabled: isLoading }}
      secondaryActionProps={{ text: 'Cancel', onClick: closeDialog }}
    >
      Once a ticket is {actionTextLower}, the patient receives a message that the issue has been
      addressed, and will no longer be able to reply.
    </MessageDialog>
  );
};
